// extends
import { ExtendedContainer, SkySpine, soundService } from '@aceroll/core';

class BackgroundFire extends ExtendedContainer {
    animations = {
        fire_in: 'fire_in',
        fire_out: 'fire_out',
        fire_idle: 'fire_idle',
        fire_transition: 'fire_transition',
        blue_fire_loop: 'blue_fire_loop',
        blue_fire_out_idle: 'blue_fire_out_idle',
    };

    constructor() {
        super('background-fire');

        this.content = this.addChild(new ExtendedContainer('background-fire'));
        this.spine = new SkySpine('spine-fire');
        this.spine.speed = 1.25;
        this.content.addChild(this.spine);
    }

    // outer

    async start() {
        await this.spine.setImmediately([
            this.animations.fire_in,
            this.animations.fire_idle
        ], true);
    }

    async playIdle() {
        this.spine.stop(true);
        await this.spine.setImmediately([
            this.animations.blue_fire_out_idle,
            this.animations.fire_idle
        ], true);
    }

    async playWin() {
        this.spine.stop(true);
        soundService.play('fire_active');
        await this.spine.setImmediately([
            this.animations.fire_transition,
            this.animations.blue_fire_loop,
            this.animations.blue_fire_out_idle,
            this.animations.fire_idle
        ], true);
    }

    async playAntisipation() {
        this.spine.stop(true);
        await this.spine.setImmediately([
            this.animations.fire_transition,
            this.animations.blue_fire_loop
        ], true);
    }

    setMainGameView() {
        this.spine.visible = true;
        this.spine.resume();
    }

    setBonusGameView() {
        this.spine.visible = false;
        this.spine.pause();
    }
}

export default BackgroundFire;
